import Details from '@/components/Details/Details';
import useFeature from '@/hooks/useFeature';
import IEventType from '@/types/IEventType';
import { IEventTypeWrite } from '@/types/apiClient/IEventTypeWrite';
import {
	Box,
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from '@chakra-ui/react';
import { FcWorkflow } from 'react-icons/fc';
import EditWorkflowView from './components/edit-workflow/edit-workflow.view';
import WorkflowItem from './components/workflow-item.view';
import { useSectionWorkflowsController } from './section-workflows.controller';

export interface IProps {
	service: IEventType;
	onChange: (values: Partial<IEventTypeWrite>) => void;
}

export default function SectionWorkflows() {
	const canSeeWorkflows = useFeature('WORKFLOWS');

	const { t, isEditWorkflowModalOpen, handleCreateWorkflowClick, closeEditWorkflowModal, handleEditWorkflowClick } =
		useSectionWorkflowsController();

	if (!canSeeWorkflows) {
		return false;
	}

	return (
		<Details image={<FcWorkflow />} title={t('Workflows')}>
			<Box display="grid" justifyContent="end">
				<Button colorScheme="primary" size="sm" onClick={handleCreateWorkflowClick}>
					{t('Add workflow')}
				</Button>
			</Box>

			<Box mt={3} display="grid" gap={1} onClick={() => handleEditWorkflowClick('123')}>
				<WorkflowItem />
			</Box>

			<Modal size="lg" isOpen={isEditWorkflowModalOpen} onClose={closeEditWorkflowModal}>
				<ModalOverlay />
				<ModalContent display="grid" gridTemplateRows="auto 1fr auto" maxH="100vh">
					<ModalHeader>
						Modal Title
						<ModalCloseButton />
					</ModalHeader>

					<ModalBody h="full" overflow="auto">
						<EditWorkflowView />
					</ModalBody>

					<ModalFooter>
						<Button colorScheme="primary">Save</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</Details>
	);
}
